/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: Collaboration
 * (C) Copyright IBM Corp. 2018
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */

define('collaboration/canvaseditor/tools/ArrowTool',['./Tool', '../shapes/ArrowShape'], function (Tool, ArrowShape) {
	'use strict';

	var ArrowTool = Tool.extend({

		/**
   * Called by constructor.
   * @param options {Object} Options
   */
		init: function init(options) {
			// eslint-disable-line no-unused-vars
			ArrowTool.inherited('init', this, arguments);
		},

		create: function create(canvas, xCoord, yCoord) {
			var arrow = new ArrowShape({
				canvas: canvas,
				xCoord: xCoord,
				yCoord: yCoord,
				borderColor: this.borderColor,
				fillColor: this.fillColor
			});
			return arrow;
		}

	});

	return ArrowTool;
});
;

var _temp = function () {
	if (typeof __REACT_HOT_LOADER__ === 'undefined') {
		return;
	}
}();

;

